export default "__VITE_ASSET__D654FaZn__"